import { render, staticRenderFns } from "./MatchupOverviewDesktop.vue?vue&type=template&id=6e001acc&scoped=true&"
import script from "./MatchupOverviewDesktop.vue?vue&type=script&lang=js&"
export * from "./MatchupOverviewDesktop.vue?vue&type=script&lang=js&"
import style0 from "./MatchupOverviewDesktop.vue?vue&type=style&index=0&id=6e001acc&lang=scss&scoped=true&"
import style1 from "./MatchupOverviewDesktop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e001acc",
  null
  
)

export default component.exports